import { render, staticRenderFns } from "./UserPublicProfileName.vue?vue&type=template&id=06d152f0"
import script from "./UserPublicProfileName.vue?vue&type=script&lang=js"
export * from "./UserPublicProfileName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports